export default function FooterContent() {
  return (
    <div>
      <div className="text-center login-copyrights">
        WesternTech © {new Date()?.getFullYear()}
      </div>
    </div>
  );
}
